/*************************************************/
/* INTERSECTION OBSERVATION                      */
/*************************************************/
import { statistics } from "./statistics";

export function intersectionObservation() {
    const activeClass = 'in-view',
        targetsClasses = [".media-counter__counter--value", ".media-counter__media", ".banner__widgets", ".video-item__player", ".counter__counter--value", ".media-content__animation"],
        options = {
            rootMargin: '200px'
        };
    const init = function () {
        let targets = [];
        for (var i = 0; i < targetsClasses.length; i++) {
            var targetElements = document.querySelectorAll(targetsClasses[i]);
            if (targetElements != null) {
                targets.push(...targetElements);
            }
        }
        if ('IntersectionObserver' in window) {
            function handleIntersection(entries) {
                entries.map((entry) => {
                    if (entry.isIntersecting) {
                        if (entry.target.dataset.autoplay) {
                            entry.target.click();
                        } else if (entry.target.classList.contains('media-counter__counter--value') || entry.target.classList.contains('counter__counter--value')) {
                            new statistics(entry.target);
                        } else if (entry.target.classList.contains('media-counter__media')) {
                            if (!window.scrollEventAttachedMedia) {
                                window.addEventListener('scroll', () => handleScroll(".media-counter__media"));
                                window.scrollEventAttachedMedia = true;
                            }
                        }  else if (entry.target.classList.contains('media-content__animation')) {
                            if (!window.scrollEventAttachedMedia) {
                                window.addEventListener('scroll', () => handleScroll(".media-content__animation"));
                                window.scrollEventAttachedMedia = true;
                            }
                        } else if (entry.target.classList.contains('banner__widgets')) {
                            if (!window.scrollEventAttachedBanner) {
                                window.addEventListener('scroll', () => widgetAnimation());
                                window.scrollEventAttachedBanner = true;
                            }
                        } else {
                            entry.target.classList.add(entry.target.classList[0] + "--" + activeClass);
                        }

                        observer.unobserve(entry.target);
                    }
                });
            }
            const observer = new IntersectionObserver(handleIntersection, options);
            targets.forEach(target => observer.observe(target));
        } else {
            targets.forEach(target => {
                target.classList.add(target.classList[0] + "--" + activeClass);
            });
        }
    };

    function handleScroll(containerClass) {
        const container = document.querySelector(containerClass);
        if (!container) return; // Exit if the container element is not found
    
        const items = container.querySelectorAll('img, .lottie'); 
        const containerRect = container.getBoundingClientRect(); 
        const containerHeight = containerRect.height; 
        const viewportHeight = window.innerHeight; 
    
        // Calculate the offset from the viewport center to the container's center
        const centerOffset = containerRect.top + containerHeight / 2 - viewportHeight / 2;
    
        // Set movement limits based on screen width
        const movementLimit = window.innerWidth < 992 ? 40 : 70;
    
        items.forEach((item) => {
            let movement = centerOffset * -0.2; // Determine movement relative to the center offset
    
            // Ensure the movement stays within defined bounds
            movement = Math.max(Math.min(movement, movementLimit), -movementLimit);
            item.style.transform = `translateY(${movement}px)`; // Apply vertical movement via CSS transform
        });
    }
    
    function widgetAnimation() {
        const scrollPosition = window.scrollY; // Get the current vertical scroll position
        const items = document.querySelectorAll('.banner__widget:not(.swiper-slide)'); // Select all widgets excluding swiper slides
    
        items.forEach((item, index) => {    
            let speed = 0.8 + (index * 0.5); // Determine the speed multiplier, faster for the first items, slower for subsequent ones
    
            let offset = scrollPosition * speed; // Calculate the vertical offset based on scroll position and speed
    
            // Apply scaling to offset for a more subtle vertical movement
            const scaledOffset = -offset * 0.5;
    
            // Move the item vertically by applying a CSS transform
            item.style.transform = `translateY(${scaledOffset}px)`;
        });
    }
    

    init();
}